// src/store/modules/user.js
import { login, createAdmin, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setCookie, getCookie } from '@/utils/support' // 需确保有 getCookie 工具

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    merchantId: null // 当前商家ID
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MERCHANT_ID: (state, merchantId) => {
      state.merchantId = merchantId
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 注册
    Register({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        createAdmin(userInfo).then(response => {
          if (response.code === 200) {
            resolve(response)
          } else {
            reject(response.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息（核心：设置 merchantId）
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data

          // 设置商家ID（若后端返回）
          if (data.merchantId) {
            commit('SET_MERCHANT_ID', data.merchantId)
            setCookie('merchantId', data.merchantId, 7) // 存入Cookie，7天有效
          } else {
            // 若后端未返回，尝试从Cookie中读取（可能之前已存）
            const cookieMerchantId = getCookie('merchantId')
            if (cookieMerchantId) {
              commit('SET_MERCHANT_ID', parseInt(cookieMerchantId))
            }
          }

          // 处理角色（管理员判断）
          if (data.roles && data.roles.length > 0) {
            commit('SET_ROLES', data.roles)
          } else {
            // 注意：即使 reject，merchantId 已设置，不影响后续通过 getCookie 获取
            reject('获取角色信息为空！请联系管理员分配角色！getInfo: roles must be a non-null array !')
            // 继续执行下面的 name/avatar 设置（可根据需求决定是否继续）
            // 若希望 reject 后不再继续，可在此直接 return
            // 此处保留原逻辑，继续设置 name 和 avatar
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_MERCHANT_ID', null)
          setCookie('merchantId', '', -1) // 清除Cookie
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_MERCHANT_ID', null)
        setCookie('merchantId', '', -1)
        removeToken()
        resolve()
      })
    }
  },

  // ===== 新增 getters =====
  getters: {
    // 当前商家ID
    merchantId: state => state.merchantId,
    // 判断是否为管理员（可根据角色名称自定义）
    isAdmin: state => {
      // 如果 roles 包含 'admin' 或角色标识为 'admin'
      return state.roles && state.roles.includes('admin')
    },
    // 当前用户名称
    username: state => state.name
  }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js